package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class WalmartAccountDeviceRelinkRequestInfo(
    val accessToken: String,
    val setupCode: String
)

@Serializable
@JsExport
internal data class WalmartAccountDeviceRelinkClientRequestInfo(
    val setupCode: String
)